import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import CaseCloseQuestionnaire from './CaseCloseQuestionnaire';
import { Size } from '../../../../Enums/Size.enum';
import { CaseDoctorSurvey } from '../../../../graphql/graphql';

interface Props extends BaseModalProps {
	onSkip: () => void;
	doctorSurvey: CaseDoctorSurvey;
}

const CaseCloseQuestionnaireModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.caseCloseQuestionnaire.modalTitle'
			size={Size.MD}>
			<CaseCloseQuestionnaire
				onSkip={props.onSkip}
				doctorSurvey={props.doctorSurvey}
			/>
		</BaseModal>
	);
};

export default CaseCloseQuestionnaireModal;
